export default __webpack_public_path__ + "static/6-74f62ff7f505cbafec12f804e95e23c6.webp";